
import React, { Component } from 'react';
import './add-user.scss'
import { Modal, ModalBody } from "reactstrap";

import SchoolApi from '../../../apis/school'
import { ImageConstants, Constants } from '../../../constants/constants';
import { getImageSource } from '../../../utility/image-source'
import PillButton from '../../common/pill-button-select/pill-button-select'

import StudentBulkUpload from '../../class/student-bulk-import/student-bulk-import';
import SessionCache from '../../routes/session-cache';
import AddStudent from '../../class/add-student/add-student'

class AddContactComponent extends Component {
    constructor(props) {
        super(props)

    }

    state = {
        sections: [],
    }
    studentsCountHash = {}
    createdUserCount = 0

    componentDidMount() {
        this.getClassAndBoard()
    }

    getClassAndBoard(payload = {}) {
        SchoolApi.getClassAndBoard(payload)
            .then(school => {
                let classes = [], boards = [];
                for (let i = 0; i < school.classes.length; i++) {
                    classes.push({
                        title: school.classes[i].name,
                        value: school.classes[i].name,
                    })
                }

                for (let i = 0; i < school.boards.length; i++) {
                    boards.push({
                        title: school.boards[i].name,
                        value: school.boards[i].name,
                    })
                }

                let selectedBoard = ""
                if (boards.length == 1) {
                    selectedBoard = boards[0].value
                }


                this.setState({ selectedBoard, class: classes, board: boards })
            }).catch(err => {
            })
    }


    getSections(payload = {}) {

        if (!payload.class) payload.class = this.state.selectedClass
        if (!payload.board) payload.board = this.state.selectedBoard

        SchoolApi.getSections(payload)
            .then(response => {
                let sections = response.response
                let arr = []
                for (let i = 0; i < sections.length; i++) {
                    let section = sections[i]
                    arr.push({
                        title: section.section,
                        value: section._id,
                    })
                }

                let selectedSection = arr[0]?.value
                let classDetails = {
                    class: this.state.selectedClass,
                    board: this.state.selectedBoard,
                    section: arr[0]?.title,
                    _id: selectedSection
                }
                this.setState({ sections: arr, selectedSection, classDetails },)
            }).catch(err => {
                this.setState({ sections: [], selectedSection: "" })
            })
    }


    onSelectClass = (option) => {
        this.selectedClass = this.state.class.filter(item => item.value == option)[0]

        this.setState({ selectedClass: option }, () => {
            this.getSections()
        })
    }

    onSelectBoard = (option) => {
        this.setState({ selectedBoard: option }, () => {
            this.getSections()
        })
    }

    onSelectSection = (option) => {
        let classDetails = {
            class: this.state.selectedClass,
            board: this.state.selectedBoard,
            _id: option?.value,
            section: option.title
        }
        this.setState({ selectedSection: option?.value, reload: true, classDetails }, () => {
            this.setState({ reload: false })
        })
    }


    onSaveStudent = (numberOfstudentAdded = 1) => {
        if (numberOfstudentAdded) {
            let studentsCountHash = this.studentsCountHash

            if (studentsCountHash[this.state.selectedSection]) {
                studentsCountHash[this.state.selectedSection] += numberOfstudentAdded
            } else {
                studentsCountHash[this.state.selectedSection] = numberOfstudentAdded
            }
            this.studentsCountHash = studentsCountHash
            let user = SessionCache.getUser()
            user.schoolInfo.totalStudents = studentsCountHash[this.state.selectedSection]
            SessionCache.setUser(user)
            this.createdUserCount += numberOfstudentAdded
        }


        this.setState({ showBulkImportModal: false, reload: true }, () => {
            this.setState({ reload: false })
        })
    }

    bulkStudentImport = () => {
        this.setState({ showBulkImportModal: true })
    }

    hideBulkStudentImport = () => {
        this.setState({ showBulkImportModal: false })
    }

    showExcelFormat = () => {
        const link = document.createElement('a');
        link.href = 'https://docs.google.com/spreadsheets/d/1gsgNHBwshq0lY5NLYcLbCHSqvSc_tpQ_gGhn50k2gfI/edit?usp=sharing';
        link.target = '_blank';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    }


    render() {
        return (
            <div className="add-new-user">
                <Modal className="cw-custom-modal-right" isOpen={this.props.show} toggle={this.props.onClose} size={this.props.size || 'md'}>

                    <ModalBody >
                        <div className="add-user">
                            <div>
                                <div className="abs-image">
                                    <img className='cursor-pointer header-image' src={getImageSource(ImageConstants.HEADER1)} />
                                </div>

                                <div className="pt-4 my-auto">
                                    <span className="step-title">STEP {this.props.step}</span>
                                    <span className="float-right">
                                        <img className='close-icon cursor-pointer' src={getImageSource(ImageConstants.CROSS)} onClick={this.props.onClose} />
                                    </span>
                                </div>

                                <div className="pt-4 my-auto">
                                    <span className="header-title">ADD STUDENTS</span>
                                    {
                                        this.props?.selectedItem?.optional ?
                                            <span className="px-2 optional-text"> OPTIONAL</span>
                                            : ""
                                    }
                                    {
                                        this.props?.selectedItem?.note ?
                                            <div className="note-text">
                                                Note : <span> <strong>Students could be added later by Teacher as well</strong></span>
                                            </div>
                                            : ""}

                                </div>

                                <div>
                                    {
                                        this.state.board?.length > 1 && <div className='pt-4'>
                                            <PillButton key={'board'} value={this.state.selectedBoard} options={this.state.board} onSelect={this.onSelectBoard} size={'md'} style={{ fontSize: 17, fontWeight: 'bold' }} />
                                        </div>
                                    }

                                    <div className='pt-4'>
                                        <PillButton key={'classes'} value={this.state.selectedClass} options={this.state.class} onSelect={this.onSelectClass} size={'md'} style={{ fontSize: 17, fontWeight: 'bold' }} />
                                    </div>
                                    {
                                        this.state?.sections?.length ?

                                            <div className="add-section">
                                                <div className={`section-tab`}>
                                                    <div className="px-4">
                                                        <div className="section-header" id="section-scroll">
                                                            {
                                                                this.state?.sections ? this.state?.sections.map((item, index) => (
                                                                    <div className={`d-inline-block px-4 py-2 curosor-pointer ${this.state.selectedSection == item.value ? "active-section-header" : "inactive-section-header"} ${index == 0 ? "left-border" : ""}`}
                                                                        onClick={() => this.onSelectSection(item)}>
                                                                        <div className="">
                                                                            {this.state.selectedHeader == index ? <span className="d-inline-block in-progress mr-2"></span> : ""}
                                                                            <span>Section - {item?.title}</span>
                                                                        </div>
                                                                    </div>
                                                                ))
                                                                    : ""
                                                            }
                                                        </div>
                                                    </div>
                                                </div>
                                                {this.state.sections?.length ?
                                                    <>{
                                                        !this.state.reload ?
                                                            <div className="cw-gradiant-card">
                                                                <div className="cw-gradiant-card-content no-padding">

                                                                    <div>
                                                                        {
                                                                            this.studentsCountHash[this.state.selectedSection] > 0 ?
                                                                                <span>
                                                                                    <img className="student-add-image" src={getImageSource(ImageConstants.TICK_GREEN)} />
                                                                                    <span className="student-added pl-2"><strong>{this.studentsCountHash[this.state.selectedSection]} Student added </strong></span>
                                                                                </span>

                                                                                :
                                                                                ""
                                                                        }

                                                                        <span className="float-right">
                                                                            <span className='bulk-button' onClick={() => this.bulkStudentImport()}>
                                                                                BULK EXCEL UPLOAD
                                                                            </span>
                                                                            <div className='check-text pt-2 text-right' onClick={this.showExcelFormat}>Check Format Here</div>
                                                                        </span>

                                                                    </div>

                                                                    <div className="mt-5">
                                                                        <AddStudent mode="CREATE" buttonName="ADD" selectedClass={this.state.classDetails} onSave={this.onSaveStudent} />
                                                                    </div>
                                                                </div>
                                                            </div> : ""
                                                    }
                                                    </> :
                                                    ""
                                                }

                                            </div> : ""
                                    }
                                </div>
                                {
                                    this.state?.sections?.length ?
                                        <div className="text-center pt-4">
                                            <button className={`cw-button-primary ${!this.createdUserCount ? "disable-button" : ""}`} onClick={this.props.onClose}>
                                                {"Save"}
                                            </button>
                                        </div> :
                                        this.state.selectedClass ?
                                            <div className="text-center pt-4"> Sections for {this.state.selectedClass} are not added, To add students you need to first add sections</div>
                                            : ""
                                }
                            </div>
                        </div>
                    </ModalBody>

                </Modal >
                {this.state.showBulkImportModal && <StudentBulkUpload mode={this.state.mode} selectedClass={this.state.classDetails} size={'lg'} onSave={this.onSaveStudent} onClose={this.hideBulkStudentImport} />}

            </div>
        );
    }
}

export default AddContactComponent;